import React, { useState, useEffect } from 'react';

const API_BASE_URL = "https://final-project-5ar7.onrender.com";

// ✅ RESPONSIVE INLINE STYLES
const styles = {
  // Container
  container: {
    padding: '20px',
    maxWidth: '100vw',
    overflowX: 'hidden'
  },
  
  // Table Container
  tableContainer: {
    marginTop: '20px',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'thin',
    scrollbarColor: '#CBD5E0 #F7FAFC'
  },
  
  // Table
  table: {
    width: '100%',
    minWidth: '900px',
    borderCollapse: 'collapse',
    background: 'white',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  
  // Table Header
  tableHeader: {
    background: '#f8fafc'
  },
  
  th: {
    padding: '12px 8px',
    textAlign: 'left',
    borderBottom: '2px solid #e2e8f0',
    fontSize: '14px',
    fontWeight: '600',
    whiteSpace: 'nowrap'
  },
  
  // Table Body
  td: {
    padding: '12px 8px',
    borderBottom: '1px solid #e2e8f0',
    fontSize: '13px',
    verticalAlign: 'middle'
  },
  
  // Type Badge
  typeBadge: {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: 'bold',
    color: 'white',
    whiteSpace: 'nowrap'
  },
  
  // Status Badge
  statusBadge: {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    textTransform: 'uppercase',
    color: 'white',
    whiteSpace: 'nowrap'
  },
  
  // Action Buttons Container
  actionButtons: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  },
  
  // Button Base
  button: {
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap'
  },
  
  // Modal Overlay
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '10px',
    overflowY: 'auto'
  },
  
  // Modal Content
  modalContent: {
    background: 'white',
    padding: '20px',
    borderRadius: '12px',
    maxWidth: '1200px',
    width: '100%',
    maxHeight: '95vh',
    overflowY: 'auto',
    margin: '10px'
  },
  
  // Modal Header
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    borderBottom: '2px solid #e5e7eb',
    paddingBottom: '15px',
    flexWrap: 'wrap',
    gap: '10px'
  },
  
  // Tab Container
  tabContainer: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  },
  
  // Tab Button
  tab: (active) => ({
    padding: '8px 16px',
    background: active ? '#3b82f6' : '#e5e7eb',
    color: active ? 'white' : '#374151',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap'
  }),
  
  // Grid Container
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginBottom: '20px'
  },
  
  // Document Grid
  documentGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px'
  },
  
  // Document Card
  documentCard: {
    padding: '15px',
    background: '#f8fafc',
    borderRadius: '8px',
    border: '1px solid #e5e7eb'
  },
  
  // Stats Card
  statsCard: (bgColor) => ({
    background: bgColor,
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center'
  }),
  
  // Input
  input: {
    padding: '6px 8px',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    fontSize: '14px',
    width: '100%',
    maxWidth: '120px'
  },
  
  // Textarea
  textarea: {
    width: '100%',
    height: '80px',
    padding: '8px',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    resize: 'vertical',
    fontSize: '14px'
  },
  
  // KYC Section
  kycSection: {
    marginBottom: '25px'
  },
  
  kycHeader: {
    background: '#10b981',
    color: 'white',
    padding: '10px 15px',
    borderRadius: '8px 8px 0 0',
    margin: '0',
    fontSize: '16px',
    fontWeight: '600'
  },
  
  kycBody: {
    background: '#f8fafc',
    padding: '20px',
    borderRadius: '0 0 8px 8px',
    border: '1px solid #e5e7eb'
  },
  
  // Transaction List
  transactionList: {
    maxHeight: '200px',
    overflowY: 'auto',
    background: '#f8fafc',
    borderRadius: '6px',
    padding: '10px'
  },
  
  transactionItem: {
    padding: '8px',
    borderBottom: '1px solid #e5e7eb',
    fontSize: '14px'
  }
};

function WithdrawalRequests() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [adminNotes, setAdminNotes] = useState('');
  const [processing, setProcessing] = useState(false);
  const [viewMode, setViewMode] = useState('review');
  const [newPin, setNewPin] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  
  // ✅ NEW: Edit mode state
  const [isEditing, setIsEditing] = useState(false);
  const [editForm, setEditForm] = useState({
    amount: '',
    withdrawalMethod: '',
    cryptoCountry: '',
    cryptoWallet: '',
    binanceId: '',
    cryptoWalletId: ''
  });
const handleViewDocument = (fileUrl, filename, title) => {
  // ✅ Use Cloudinary URL directly — no local server needed
  const url = fileUrl || `${API_BASE_URL}/uploads/transactions/${filename}`;
  window.open(url, '_blank', 'noopener,noreferrer');
  console.log(`📄 Opening: ${title}`);
};


  // Detect mobile/tablet
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const fetchWithdrawals = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/all-withdrawals`);
      const data = await response.json();
      setWithdrawals(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching withdrawals:', error);
      setLoading(false);
    }
  };

  const fetchUserProfile = async (userId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/user-profile/${userId}`);
      const data = await response.json();
      if (data.success) {
        setUserProfile(data.userProfile);
      } else {
        alert('❌ Failed to load user profile');
      }
    } catch (error) {
      console.error('❌ Error fetching user profile:', error);
      alert('❌ Network error while loading user profile');
    }
  };

  const handleResetPin = async () => {
    if (!newPin || newPin.length < 4) {
      alert('❌ PIN must be at least 4 digits');
      return;
    }

    if (!userProfile?.basicInfo?._id) {
      alert('❌ User ID not found');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/reset-user-pin/${userProfile.basicInfo._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          newPin,
          adminNotes: `PIN reset due to user request - Original PIN forgotten`
        })
      });

      if (response.ok) {
        alert('✅ User PIN reset successfully!');
        setNewPin('');
        await fetchUserProfile(userProfile.basicInfo._id);
      } else {
        const error = await response.json();
        alert(`❌ Error resetting PIN: ${error.message}`);
      }
    } catch (error) {
      console.error('❌ Error resetting PIN:', error);
      alert('❌ Network error occurred');
    }
  };

  const handleApprove = async (withdrawalId) => {
    setProcessing(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/approve-withdrawal/${withdrawalId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ adminNotes })
      });

      if (response.ok) {
        alert('✅ Withdrawal approved successfully!');
        fetchWithdrawals();
        setSelectedWithdrawal(null);
        setUserProfile(null);
        setAdminNotes('');
        setViewMode('review');
      } else {
        const error = await response.json();
        alert(`❌ Error: ${error.message}`);
      }
    } catch (error) {
      console.error('Error approving withdrawal:', error);
      alert('❌ Network error occurred');
    }
    setProcessing(false);
  };

  const handleReject = async (withdrawalId) => {
    if (!adminNotes.trim()) {
      alert('❌ Please provide rejection reason');
      return;
    }

    setProcessing(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/reject-withdrawal/${withdrawalId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ adminNotes })
      });

      if (response.ok) {
        alert('❌ Withdrawal rejected');
        fetchWithdrawals();
        setSelectedWithdrawal(null);
        setUserProfile(null);
        setAdminNotes('');
        setViewMode('review');
      } else {
        const error = await response.json();
        alert(`❌ Error: ${error.message}`);
      }
    } catch (error) {
      console.error('Error rejecting withdrawal:', error);
      alert('❌ Network error occurred');
    }
    setProcessing(false);
  };

  const handleViewDetails = async (withdrawal) => {
    setSelectedWithdrawal(withdrawal);
    setViewMode('review');
    setIsEditing(false);
    
    // Initialize edit form with current values
    setEditForm({
      amount: withdrawal.amount,
      withdrawalMethod: withdrawal.withdrawalMethod || 'standard',
      cryptoCountry: withdrawal.cryptoCountry || '',
      cryptoWallet: withdrawal.cryptoWallet || '',
      binanceId: withdrawal.binanceId || '',
      cryptoWalletId: withdrawal.cryptoWalletId || ''
    });
    
    if (withdrawal.userId?._id) {
      await fetchUserProfile(withdrawal.userId._id);
    }
  };

  // ✅ NEW: Handle edit save
  const handleSaveEdit = async () => {
    if (!editForm.amount || editForm.amount < 10) {
      alert('❌ Minimum withdrawal amount is $10');
      return;
    }

    setProcessing(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/update-withdrawal/${selectedWithdrawal._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...editForm,
          adminNotes: `Edited by admin: ${adminNotes || 'Updated withdrawal details'}`
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert('✅ Withdrawal updated successfully!');
        setIsEditing(false);
        setAdminNotes('');
        await fetchWithdrawals();
        setSelectedWithdrawal(data.withdrawal);
      } else {
        alert(`❌ Error: ${data.message}`);
      }
    } catch (error) {
      console.error('Error updating withdrawal:', error);
      alert('❌ Network error occurred');
    }
    setProcessing(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'submitted': return '#f59e0b';
      case 'pending': return '#3b82f6';
      case 'approved': return '#10b981';
      case 'rejected': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getWithdrawalTypeLabel = (type) => {
    switch (type) {
      case 'first_time_kyc': return '🆕 First-Time KYC';
      case 'repeat_id_verification': return '🔄 ID Verification';
      case 'pin_only': return '🔢 PIN Only';
      default: return '📋 Legacy KYC';
    }
  };

  const getWithdrawalTypeColor = (type) => {
    switch (type) {
      case 'first_time_kyc': return '#8b5cf6';
      case 'repeat_id_verification': return '#f59e0b';
      case 'pin_only': return '#10b981';
      default: return '#6b7280';
    }
  };

  if (loading) {
    return (
      <div style={{ ...styles.container, textAlign: 'center', padding: '60px 20px' }}>
        <div style={{ fontSize: '18px', color: '#6b7280' }}>🔄 Loading withdrawals...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h1 style={{ fontSize: isMobile ? '24px' : '32px', marginBottom: '10px' }}>Withdrawal Requests</h1>
      <p style={{ color: '#6b7280', marginBottom: '20px' }}>Review and approve withdrawal requests with different verification types.</p>

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead style={styles.tableHeader}>
            <tr>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>User</th>
              <th style={styles.th}>Account</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Status</th>
              <th style={{...styles.th, position: 'sticky', right: 0, background: '#f8fafc', boxShadow: '-2px 0 4px rgba(0,0,0,0.1)'}}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map((withdrawal) => (
              <tr key={withdrawal._id}>
                <td style={styles.td}>{new Date(withdrawal.createdAt).toLocaleDateString()}</td>
                <td style={styles.td}>
                  <span style={{
                    ...styles.typeBadge,
                    background: getWithdrawalTypeColor(withdrawal.withdrawalType)
                  }}>
                    {getWithdrawalTypeLabel(withdrawal.withdrawalType)}
                  </span>
                </td>
                <td style={styles.td}>
                  <div>
                    {withdrawal.withdrawalType === 'first_time_kyc' ? withdrawal.fullName : 'Existing User'}
                  </div>
                  <small style={{ color: '#6b7280' }}>{withdrawal.userId?.email}</small>
                </td>
                <td style={styles.td}>{withdrawal.tradeAccount}</td>
                <td style={{...styles.td, fontWeight: 'bold'}}>${withdrawal.amount}</td>
                <td style={styles.td}>
                  <span style={{
                    ...styles.statusBadge,
                    background: getStatusColor(withdrawal.status)
                  }}>
                    {withdrawal.status}
                  </span>
                </td>
                <td style={{...styles.td, position: 'sticky', right: 0, background: 'white', boxShadow: '-2px 0 4px rgba(0,0,0,0.05)'}}>
                  <div style={styles.actionButtons}>
                    <button 
                      onClick={() => handleViewDetails(withdrawal)}
                      style={{ 
                        ...styles.button,
                        background: '#6366f1',
                        color: 'white'
                      }}
                    >
                      📋 View
                    </button>
                    
                    {(withdrawal.status === 'submitted' || withdrawal.status === 'pending') && (
                      <button 
                        onClick={() => handleViewDetails(withdrawal)}
                        style={{ 
                          ...styles.button,
                          background: '#3b82f6',
                          color: 'white'
                        }}
                      >
                        🔍 Review
                      </button>
                    )}
                    
                    {withdrawal.status === 'approved' && (
                      <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '12px' }}>✅</span>
                    )}
                    {withdrawal.status === 'rejected' && (
                      <span style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '12px' }}>❌</span>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ✅ MODAL WITH EDIT FUNCTIONALITY */}
      {selectedWithdrawal && (
        <div style={styles.modalOverlay}>
          <div style={{
            ...styles.modalContent,
            padding: isMobile ? '15px' : '30px'
          }}>
            
            {/* Modal Header */}
            <div style={styles.modalHeader}>
              <h2 style={{ 
                margin: 0, 
                fontSize: isMobile ? '18px' : '24px',
                flex: 1 
              }}>
                {isEditing ? '✏️ Edit Withdrawal' : 'User Details & Withdrawal Review'}
              </h2>
              
              <div style={styles.tabContainer}>
                {!isEditing && (
                  <>
                    <button
                      onClick={() => setViewMode('review')}
                      style={styles.tab(viewMode === 'review')}
                    >
                      🔍 {isMobile ? 'Request' : 'Current Request'}
                    </button>
                    
                    <button
                      onClick={() => setViewMode('profile')}
                      style={styles.tab(viewMode === 'profile')}
                    >
                      👤 {isMobile ? 'Profile' : 'Complete Profile'}
                    </button>

                    {/* ✅ NEW: Edit button */}
                    {(selectedWithdrawal.status === 'submitted' || selectedWithdrawal.status === 'pending') && (
                      <button
                        onClick={() => setIsEditing(true)}
                        style={{
                          ...styles.button,
                          background: '#f59e0b',
                          color: 'white',
                          padding: '8px 16px'
                        }}
                      >
                        ✏️ Edit
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>

            {/* ✅ NEW: EDIT MODE VIEW */}
            {isEditing && (
              <div>
                <div style={{
                  background: '#fef3c7',
                  padding: '15px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  border: '2px solid #f59e0b'
                }}>
                  <h3 style={{ margin: '0 0 10px 0', color: '#92400e' }}>✏️ Edit Withdrawal Details</h3>
                  <p style={{ margin: 0, fontSize: '14px', color: '#78350f' }}>
                    Modify the withdrawal details below. Changes will be saved and visible to the user immediately.
                  </p>
                </div>

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                  gap: '20px',
                  marginBottom: '20px'
                }}>
                  {/* Amount */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                      Amount (USD) *
                    </label>
                    <input
                      type="number"
                      value={editForm.amount}
                      onChange={(e) => setEditForm({...editForm, amount: e.target.value})}
                      min="50"
                      style={{
                        ...styles.input,
                        maxWidth: '100%',
                        fontSize: '16px',
                        padding: '10px'
                      }}
                    />
                  </div>

                  {/* Withdrawal Method */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                      Withdrawal Method *
                    </label>
                    <select
                      value={editForm.withdrawalMethod}
                      onChange={(e) => setEditForm({...editForm, withdrawalMethod: e.target.value})}
                      style={{
                        ...styles.input,
                        maxWidth: '100%',
                        fontSize: '14px',
                        padding: '10px'
                      }}
                    >
                      <option value="standard">Standard</option>
                      <option value="crypto">Crypto</option>
                      <option value="bank">Bank Transfer</option>
                    </select>
                  </div>

                  {/* Crypto Fields */}
                  {editForm.withdrawalMethod === 'crypto' && (
                    <>
                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                          Crypto Country
                        </label>
                        <select
                          value={editForm.cryptoCountry}
                          onChange={(e) => setEditForm({...editForm, cryptoCountry: e.target.value})}
                          style={{
                            ...styles.input,
                            maxWidth: '100%',
                            fontSize: '14px',
                            padding: '10px'
                          }}
                        >
                          <option value="">Select Country</option>
                          <option value="global">Global</option>
                          <option value="england">England</option>
                          <option value="uae">UAE</option>
                          <option value="usa">USA</option>
                        </select>
                      </div>

                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                          Crypto Wallet
                        </label>
                        <select
                          value={editForm.cryptoWallet}
                          onChange={(e) => setEditForm({...editForm, cryptoWallet: e.target.value})}
                          style={{
                            ...styles.input,
                            maxWidth: '100%',
                            fontSize: '14px',
                            padding: '10px'
                          }}
                        >
                          <option value="">Select Wallet</option>
                          <option value="binance">Binance</option>
                          <option value="trust_wallet">Trust Wallet</option>
                        </select>
                      </div>

                      {editForm.cryptoWallet === 'binance' && (
                        <div>
                          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                            Binance ID
                          </label>
                          <input
                            type="text"
                            value={editForm.binanceId}
                            onChange={(e) => setEditForm({...editForm, binanceId: e.target.value})}
                            maxLength="30"
                            style={{
                              ...styles.input,
                              maxWidth: '100%',
                              padding: '10px'
                            }}
                          />
                        </div>
                      )}

                      {editForm.cryptoWallet === 'trust_wallet' && (
                        <div>
                          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                            Trust Wallet ID
                          </label>
                          <input
                            type="text"
                            value={editForm.cryptoWalletId}
                            onChange={(e) => setEditForm({...editForm, cryptoWalletId: e.target.value})}
                            maxLength="30"
                            style={{
                              ...styles.input,
                              maxWidth: '100%',
                              padding: '10px'
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Edit Notes */}
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                    Admin Notes (Optional)
                  </label>
                  <textarea
                    value={adminNotes}
                    onChange={(e) => setAdminNotes(e.target.value)}
                    placeholder="Reason for editing..."
                    style={styles.textarea}
                  />
                </div>

                {/* Edit Action Buttons */}
                <div style={{ 
                  display: 'flex', 
                  gap: '12px',
                  flexDirection: isMobile ? 'column' : 'row'
                }}>
                  <button
                    onClick={handleSaveEdit}
                    disabled={processing}
                    style={{ 
                      ...styles.button,
                      background: '#10b981',
                      color: 'white',
                      padding: '12px 24px',
                      opacity: processing ? 0.6 : 1,
                      cursor: processing ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {processing ? 'Saving...' : '💾 Save Changes'}
                  </button>
                  
                  <button
                    onClick={() => {
                      setIsEditing(false);
                      setAdminNotes('');
                      setEditForm({
                        amount: selectedWithdrawal.amount,
                        withdrawalMethod: selectedWithdrawal.withdrawalMethod || 'standard',
                        cryptoCountry: selectedWithdrawal.cryptoCountry || '',
                        cryptoWallet: selectedWithdrawal.cryptoWallet || '',
                        binanceId: selectedWithdrawal.binanceId || '',
                        cryptoWalletId: selectedWithdrawal.cryptoWalletId || ''
                      });
                    }}
                    disabled={processing}
                    style={{ 
                      ...styles.button,
                      background: '#6b7280',
                      color: 'white',
                      padding: '12px 24px',
                      cursor: processing ? 'not-allowed' : 'pointer'
                    }}
                  >
                    ❌ Cancel
                  </button>
                </div>
              </div>
            )}

            {/* Current Request Tab */}
            {viewMode === 'review' && !isEditing && (
              <div>
                <div style={{
                  ...styles.gridContainer,
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)'
                }}>
                  {/* Transaction Details */}
                  <div>
                    <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>Transaction Details</h3>
                    <p><strong>Trade Account:</strong> {selectedWithdrawal.tradeAccount}</p>
                    <p><strong>Amount:</strong> ${selectedWithdrawal.amount}</p>
                    <p><strong>Date:</strong> {new Date(selectedWithdrawal.createdAt).toLocaleString()}</p>
                    <p><strong>Type:</strong> {getWithdrawalTypeLabel(selectedWithdrawal.withdrawalType)}</p>
                    <p>
                      <strong>Status:</strong> 
                      <span style={{
                        ...styles.statusBadge,
                        background: getStatusColor(selectedWithdrawal.status),
                        marginLeft: '8px'
                      }}>
                        {selectedWithdrawal.status.toUpperCase()}
                      </span>
                    </p>
                  </div>

                  {/* User Information */}
                  <div>
                    <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>User Information</h3>
                    <p><strong>Email:</strong> {selectedWithdrawal.userId?.email}</p>
                    {selectedWithdrawal.withdrawalType === 'first_time_kyc' && (
                      <>
                        <p><strong>Full Name:</strong> {selectedWithdrawal.fullName}</p>
                        <p><strong>WhatsApp:</strong> {selectedWithdrawal.whatsappNumber}</p>
                        <p><strong>Gender:</strong> {selectedWithdrawal.gender}</p>
                        <p><strong>Trading Experience:</strong> {selectedWithdrawal.tradingExperience}</p>
                      </>
                    )}
                    {selectedWithdrawal.withdrawalType === 'pin_only' && (
                      <p style={{ color: '#10b981', fontWeight: 'bold' }}>✅ PIN verified automatically</p>
                    )}
                  </div>
                </div>

                {/* Documents */}
                {(selectedWithdrawal.identityProof || selectedWithdrawal.proofOfResidence) && (
                  <div style={{ marginBottom: '20px' }}>
                    <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>Documents for This Request</h3>
                    <div style={styles.documentGrid}>
                      {selectedWithdrawal.identityProof && (
                        <div style={styles.documentCard}>
                          <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>🆔 Identity Proof</h4>
                          <p style={{ fontSize: '13px', margin: '5px 0' }}><strong>File:</strong> {selectedWithdrawal.identityProof.originalName}</p>
                          <p style={{ fontSize: '13px', margin: '5px 0' }}><strong>Size:</strong> {Math.round(selectedWithdrawal.identityProof.size / 1024)} KB</p>
                        // ✅ NEW: Download buttons
<button
  onClick={() => handleViewDocument(
    selectedWithdrawal.identityProof.url,
    selectedWithdrawal.identityProof.filename,
    `Identity_Proof_${selectedWithdrawal.identityProof.originalName}`
  )}
  style={{ ...styles.button, background: '#10b981', color: 'white', marginTop: '10px' }}
>
  📄 View Identity Proof
</button>

                        </div>
                      )}
                      
                      {selectedWithdrawal.proofOfResidence && (
                        <div style={styles.documentCard}>
                          <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>🏠 Proof of Residence</h4>
                          <p style={{ fontSize: '13px', margin: '5px 0' }}><strong>File:</strong> {selectedWithdrawal.proofOfResidence.originalName}</p>
                          <p style={{ fontSize: '13px', margin: '5px 0' }}><strong>Size:</strong> {Math.round(selectedWithdrawal.proofOfResidence.size / 1024)} KB</p>
                    <button
  onClick={() => handleViewDocument(
    selectedWithdrawal.proofOfResidence.url,
    selectedWithdrawal.proofOfResidence.filename,
    `Proof_of_Residence_${selectedWithdrawal.proofOfResidence.originalName}`
  )}
  style={{ ...styles.button, background: '#10b981', color: 'white', marginTop: '10px' }}
>
  📄 View Proof of Residence
</button>


                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Admin Actions */}
                {(selectedWithdrawal.status === 'submitted' || selectedWithdrawal.status === 'pending') && (
                  <>
                    <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                        Admin Notes:
                      </label>
                      <textarea
                        value={adminNotes}
                        onChange={(e) => setAdminNotes(e.target.value)}
                        placeholder="Add notes (optional for approval, required for rejection)..."
                        style={styles.textarea}
                      />
                    </div>

                    <div style={{ 
                      display: 'flex', 
                      gap: '12px', 
                      marginBottom: '20px',
                      flexDirection: isMobile ? 'column' : 'row'
                    }}>
                      <button
                        onClick={() => handleApprove(selectedWithdrawal._id)}
                        disabled={processing}
                        style={{ 
                          ...styles.button,
                          background: '#10b981',
                          color: 'white',
                          padding: '12px 24px',
                          opacity: processing ? 0.6 : 1,
                          cursor: processing ? 'not-allowed' : 'pointer'
                        }}
                      >
                        {processing ? 'Processing...' : '✅ Approve Withdrawal'}
                      </button>
                      
                      <button
                        onClick={() => handleReject(selectedWithdrawal._id)}
                        disabled={processing}
                        style={{ 
                          ...styles.button,
                          background: '#ef4444',
                          color: 'white',
                          padding: '12px 24px',
                          opacity: processing ? 0.6 : 1,
                          cursor: processing ? 'not-allowed' : 'pointer'
                        }}
                      >
                        {processing ? 'Processing...' : '❌ Reject Withdrawal'}
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}

            {/* Profile Tab */}
            {viewMode === 'profile' && !isEditing && userProfile && (
              <div>
                {/* Stats */}
                <div style={{
                  ...styles.gridContainer,
                  marginBottom: '25px'
                }}>
                  <div style={styles.statsCard('#f0f9ff')}>
                    <h4 style={{ margin: '0 0 5px 0', color: '#0369a1', fontSize: '14px' }}>Total Balance</h4>
                    <p style={{ fontSize: '18px', fontWeight: 'bold', margin: 0, color: '#0369a1' }}>
                      ${userProfile.stats?.totalBalance?.toLocaleString() || 0}
                    </p>
                  </div>
                  <div style={styles.statsCard('#f0fdf4')}>
                    <h4 style={{ margin: '0 0 5px 0', color: '#166534', fontSize: '14px' }}>Total Deposits</h4>
                    <p style={{ fontSize: '18px', fontWeight: 'bold', margin: 0, color: '#166534' }}>
                      ${userProfile.stats?.totalDeposits?.toLocaleString() || 0}
                    </p>
                  </div>
                  <div style={styles.statsCard('#fef2f2')}>
                    <h4 style={{ margin: '0 0 5px 0', color: '#991b1b', fontSize: '14px' }}>Total Withdrawals</h4>
                    <p style={{ fontSize: '18px', fontWeight: 'bold', margin: 0, color: '#991b1b' }}>
                      ${userProfile.stats?.totalWithdrawals?.toLocaleString() || 0}
                    </p>
                  </div>
                  <div style={styles.statsCard('#fdf4ff')}>
                    <h4 style={{ margin: '0 0 5px 0', color: '#7c2d12', fontSize: '14px' }}>Trading Accounts</h4>
                    <p style={{ fontSize: '18px', fontWeight: 'bold', margin: 0, color: '#7c2d12' }}>
                      {userProfile.stats?.approvedAccounts || 0} Active
                    </p>
                  </div>
                </div>

                {/* KYC Profile */}
                {userProfile.kycProfile && (
                  <div style={styles.kycSection}>
                    <h3 style={styles.kycHeader}>
                      ✅ KYC Profile (Verified)
                    </h3>
                    <div style={styles.kycBody}>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                        gap: '20px'
                      }}>
                        <div>
                          <p style={{ fontSize: '14px', margin: '8px 0' }}><strong>Full Name:</strong> {userProfile.kycProfile.fullName}</p>
                          <p style={{ fontSize: '14px', margin: '8px 0' }}><strong>WhatsApp:</strong> {userProfile.kycProfile.whatsappNumber}</p>
                          <p style={{ fontSize: '14px', margin: '8px 0' }}><strong>Gender:</strong> {userProfile.kycProfile.gender}</p>
                        </div>
                        <div>
                          <p style={{ fontSize: '14px', margin: '8px 0' }}><strong>Trading Experience:</strong> {userProfile.kycProfile.tradingExperience}</p>
                          <p style={{ fontSize: '14px', margin: '8px 0' }}><strong>KYC Approved:</strong> {new Date(userProfile.kycProfile.firstApprovedAt).toLocaleDateString()}</p>
                          <p style={{ fontSize: '14px', margin: '8px 0' }}>
                            <strong>Current PIN:</strong> 
                            <span style={{ 
                              background: '#fee2e2', 
                              color: '#991b1b', 
                              padding: '2px 6px', 
                              borderRadius: '4px',
                              fontFamily: 'monospace',
                              fontWeight: 'bold',
                              marginLeft: '8px'
                            }}>
                              {userProfile.kycProfile.withdrawalPin}
                            </span>
                          </p>
                        </div>
                        <div>
                          <h4 style={{ fontSize: '14px', margin: '0 0 10px 0' }}>🔄 Reset PIN</h4>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <input
                              type="text"
                              placeholder="New PIN"
                              value={newPin}
                              onChange={(e) => setNewPin(e.target.value)}
                              style={styles.input}
                            />
                            <button
                              onClick={handleResetPin}
                              style={{ 
                                ...styles.button,
                                background: '#f59e0b',
                                color: 'white'
                              }}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Stored Documents */}
                      {(userProfile.kycProfile.storedIdentityProof || userProfile.kycProfile.storedProofOfResidence) && (
                        <div style={{ marginTop: '20px' }}>
                          <h4 style={{ fontSize: '14px', marginBottom: '10px' }}>📁 Stored KYC Documents</h4>
                          <div style={styles.documentGrid}>
                            {userProfile.kycProfile.storedIdentityProof && (
                              <div style={{ ...styles.documentCard, background: '#e0f2fe' }}>
                                <h5 style={{ margin: '0 0 8px 0', fontSize: '13px' }}>🆔 Stored Identity Proof</h5>
                                <p style={{ fontSize: '12px', margin: '5px 0' }}><strong>File:</strong> {userProfile.kycProfile.storedIdentityProof.originalName}</p>
                                {/* ✅ NEW: Download button for stored identity proof */}
<button
  onClick={() => handleViewDocument(
    userProfile.kycProfile.storedIdentityProof.url,
    userProfile.kycProfile.storedIdentityProof.filename,
    `Stored_Identity_Proof_${userProfile.kycProfile.storedIdentityProof.originalName}`
  )}
  style={{ ...styles.button, background: '#0369a1', color: 'white', marginTop: '8px', fontSize: '11px' }}
>
  📄 View Stored Identity Proof
</button>

                              </div>
                            )}
                            
                            {userProfile.kycProfile.storedProofOfResidence && (
                              <div style={{ ...styles.documentCard, background: '#ecfdf5' }}>
                                <h5 style={{ margin: '0 0 8px 0', fontSize: '13px' }}>🏠 Stored Proof of Residence</h5>
                                <p style={{ fontSize: '12px', margin: '5px 0' }}><strong>File:</strong> {userProfile.kycProfile.storedProofOfResidence.originalName}</p>
                              {/* ✅ NEW: Download button for stored proof of residence */}
<button
  onClick={() => handleViewDocument(
    userProfile.kycProfile.storedProofOfResidence.url,
    userProfile.kycProfile.storedProofOfResidence.filename,
    `Stored_Proof_of_Residence_${userProfile.kycProfile.storedProofOfResidence.originalName}`
  )}
  style={{ ...styles.button, background: '#166534', color: 'white', marginTop: '8px', fontSize: '11px' }}
>
  📄 View Proof of Residence
</button>

                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Recent Transactions */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                  gap: '20px'
                }}>
                  {/* Recent Deposits */}
                  <div>
                    <h4 style={{ fontSize: '14px' }}>💰 Recent Deposits ({userProfile.deposits?.length || 0})</h4>
                    <div style={styles.transactionList}>
                      {userProfile.deposits?.slice(0, 5).map((deposit) => (
                        <div key={deposit._id} style={styles.transactionItem}>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span>{new Date(deposit.createdAt).toLocaleDateString()}</span>
                            <span style={{ fontWeight: 'bold' }}>${deposit.amount}</span>
                          </div>
                          <div style={{ fontSize: '12px', color: '#6b7280' }}>
                            {deposit.gateway} • {deposit.status}
                          </div>
                        </div>
                      )) || <p style={{ color: '#6b7280', fontStyle: 'italic', margin: '10px' }}>No deposits found</p>}
                    </div>
                  </div>

                  {/* Recent Withdrawals */}
                  <div>
                    <h4 style={{ fontSize: '14px' }}>💸 Recent Withdrawals ({userProfile.withdrawals?.length || 0})</h4>
                    <div style={styles.transactionList}>
                      {userProfile.withdrawals?.slice(0, 5).map((withdrawal) => (
                        <div key={withdrawal._id} style={styles.transactionItem}>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span>{new Date(withdrawal.createdAt).toLocaleDateString()}</span>
                            <span style={{ fontWeight: 'bold' }}>${withdrawal.amount}</span>
                          </div>
                          <div style={{ fontSize: '12px', color: '#6b7280' }}>
                            {getWithdrawalTypeLabel(withdrawal.withdrawalType)} • {withdrawal.status}
                          </div>
                        </div>
                      )) || <p style={{ color: '#6b7280', fontStyle: 'italic', margin: '10px' }}>No withdrawals found</p>}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Close Button */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'flex-end', 
              marginTop: '20px',
              paddingTop: '20px',
              borderTop: '1px solid #e5e7eb'
            }}>
              <button
                onClick={() => {
                  setSelectedWithdrawal(null);
                  setUserProfile(null);
                  setAdminNotes('');
                  setViewMode('review');
                  setNewPin('');
                  setIsEditing(false);
                }}
                disabled={processing}
                style={{ 
                  ...styles.button,
                  background: '#6b7280',
                  color: 'white',
                  padding: '12px 24px',
                  cursor: processing ? 'not-allowed' : 'pointer',
                  width: isMobile ? '100%' : 'auto'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    

    </div>
  );
}

export default WithdrawalRequests;
